import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPeriodicidadeCompra } from '../interfaces/periodicidade-compra.interface';
import { IPeriodicidadeCompraRequest } from '../interfaces/periodicidade-compra-request.interface';
import { environment } from 'environments/environment';
import { IPeriodicidadeCompraResponse } from '../interfaces/periodicidade-compra-response.interface';
import { IPeriodicidadeCompraFilter } from '../interfaces/periodicidade-compra-filter.interface';
import { buildHttpParams } from 'app/core/utils/http-util';
import { IPeriodicidadeCompraListResponse } from '../interfaces/periodicidade-compra-list-request.interface';

@Injectable({
  providedIn: 'root',
})
export class PeriodicidadeCompraApi {
  private apiUrl = 'v1/environment/periodicidades-compras';

  constructor(private http: HttpClient) {}

  fetchPeriodicidadeCompraById(id: number): Observable<IPeriodicidadeCompra> {
    return this.http.get<IPeriodicidadeCompra>(
      `${environment.pathApi}/${this.apiUrl}/${id}`
    );
  }

  fetchPeriodicidadesCompras(
    filter: IPeriodicidadeCompraFilter
  ): Observable<IPeriodicidadeCompraResponse> {
    const params = buildHttpParams(filter);

    return this.http.get<IPeriodicidadeCompraResponse>(
      `${environment.pathApi}/${this.apiUrl}`,
      { params }
    );
  }

  fetchPeriodicidadesComprasList(
    filter?: IPeriodicidadeCompraFilter
  ): Observable<IPeriodicidadeCompraListResponse> {
    const params = buildHttpParams(filter);

    return this.http.get<IPeriodicidadeCompraListResponse>(
      `${environment.pathApi}/${this.apiUrl}/0/list`,
      { params }
    );
  }

  create(dto: IPeriodicidadeCompraRequest): Observable<IPeriodicidadeCompra> {
    return this.http.post<IPeriodicidadeCompra>(
      `${environment.pathApi}/${this.apiUrl}`,
      dto
    );
  }

  update(
    id: number,
    dto: IPeriodicidadeCompraRequest
  ): Observable<IPeriodicidadeCompra> {
    return this.http.put<IPeriodicidadeCompra>(
      `${environment.pathApi}/${this.apiUrl}/${id}`,
      dto
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(
      `${environment.pathApi}/${this.apiUrl}/${id}`
    );
  }
}
